import React, { useState, useEffect } from 'react'
import { Box, TextInput, Textarea, Select, Flex, Group, Button } from '@mantine/core'
import { validation } from '../../../../../plugins/validation'
import { orderCategory, orderType, orderTerms, orderLoadType } from '../../../../../helper/master-unit'
import { useSelector, useDispatch } from 'react-redux'
import { updateOrder } from '../../../../../services/orders'
import { useParams } from 'react-router-dom'
import { getOrderDetail } from '../../../../../store/orderDetail'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'

const defaultVal = {
  order_type: 'trading',
  order_category: 'local',
  terms: 'EXW',
  terms_note: '',
  load_type: 'FCL',
  undername: ''
}

const formValidation = {
  order_type: {
    isError: false,
    message: ''
  },
  terms: {
    isError: false,
    message: ''
  },
  load_type: {
    isError: false,
    message: ''
  },
}

const FormAdjustGeneralInfo = ({ onCloseForm }) => {
  const { summary, general } = useSelector(state => state.order_detail)
  const dispatch = useDispatch()
  const params = useParams()
  const orderId = params.order_id
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [loadingForm, setLoadingForm] = useState(false)

  const submitUpdateOrder = async (form) => {
    setLoadingForm(true)
    setValidationForm(formValidation)
    const validateForm = {
      order_type: form.order_type,
      terms: form.terms,
      load_type: form.load_type,
    }
    const isError = validation(validateForm, setValidationForm)
    if (isError) {
      setLoadingForm(false)
      return
    }
    try {
      const response = await updateOrder(orderId, form)
      if (response.success) {
        onCloseForm()
        dispatch(getOrderDetail(orderId))
        notificationSuccess('Update Order Successfully', 'This data has been updated')
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Order Error', `${errorMessage ? errorMessage : 'Please recheck your form'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  useEffect(() => {
    if (summary && general) {
      handleSetForm(summary, general)
    }
  }, [summary, general])

  const handleSetForm = (valueSummary, valueGeneral) => {
    const dataDetail = {
      order_type: valueSummary.type,
      order_category: valueSummary.category,
      terms: valueGeneral.terms,
      terms_note: valueGeneral.terms_note,
      load_type: valueGeneral.loadType,
      undername: valueGeneral.undername
    }
    setFormData(dataDetail)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }
  return (
    <Box>
      <Box mb='md'>
        <Select
          name='order_type'
          value={formData.order_type}
          label='Order Type'
          placeholder='Select Order Type'
          data={orderType}
          onChange={(val) => handleChangeForm('order_type', val)}
          error={validationForm.order_type.isError ? `${validationForm.order_type.message}` : ''}
          size='xs'
          allowDeselect={false}
          withAsterisk
        />
      </Box>
      <Box mb='md'>
        <Select
          name='order_category'
          value={formData.order_category}
          label='Order Category'
          placeholder='Select Order Category'
          data={orderCategory}
          onChange={(val) => handleChangeForm('order_category', val)}
          size='xs'
          clearable
        />
      </Box>
      <Box mb='md'>
        <Select
          name='terms'
          value={formData.terms}
          label='Terms'
          placeholder='Select Terms'
          data={orderTerms}
          onChange={(val) => handleChangeForm('terms', val)}
          error={validationForm.terms.isError ? `${validationForm.terms.message}` : ''}
          size='xs'
          allowDeselect={false}
          withAsterisk
        />
      </Box>
      <Box mb='md'>
        <Textarea
          name='terms_note'
          label="Terms Note"
          placeholder="Input terms note"
          value={formData.terms_note}
          onChange={(val) => handleChangeForm('terms_note', val.target.value)}
          size='xs'
          autosize
          minRows={4}
          maxRows={4}
        />
      </Box>
      <Box mb='md'>
        <Select
          name='load_type'
          value={formData.load_type}
          label='Load Type'
          placeholder='Select Load Type'
          data={orderLoadType}
          onChange={(val) => handleChangeForm('load_type', val)}
          error={validationForm.load_type.isError ? `${validationForm.load_type.message}` : ''}
          size='xs'
          allowDeselect={false}
          withAsterisk
        />
      </Box>
      <Box mb='md'>
        <TextInput
          name='undername'
          value={formData.undername}
          label='Undername'
          placeholder='Input undername'
          onChange={(val) => handleChangeForm('undername', val.target.value)}
          size='xs'
        />
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitUpdateOrder(formData)}>{summary ? 'Update' : 'Create'}</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAdjustGeneralInfo